import { type Editor, EditorContent } from "@tiptap/react";
import clsx from "clsx";

import { TEMPLATE_TYPES } from "features/templates/constants";
import type { TemplateType } from "features/templates/types";
import { stringifyTemplateContent } from "features/templates/utils";

import { getSchemaMaxLength } from "common/helpers/utils";

import type { JSX } from "react";

interface TemplateMessageEditorProps {
  editor: Editor;
  templateType: Exclude<TemplateType, "VOICE_TEMPLATE">;
  attachmentsComponent: JSX.Element;
  languageDropdownComponent?: JSX.Element;
}

export default function TemplateMessageEditor({
  editor,
  templateType,
  attachmentsComponent,
  languageDropdownComponent = null,
}: TemplateMessageEditorProps) {
  const { validationSchema } = TEMPLATE_TYPES[templateType];
  const templateMaxLength = getSchemaMaxLength(
    validationSchema.entries.message,
  );
  const characterCount = stringifyTemplateContent(editor.getJSON()).length;

  return (
    <>
      <div className="flex flex-col p-2 lg:px-3 flex-1 overflow-hidden">
        <EditorContent
          id="editorContent"
          editor={editor}
          className="flex-1 overflow-y-auto transition-[color] scrollbar-thin text-md lg:text-sm h-full focus:outline-none [&_.node-variable]:align-middle [&_.node-aiVariable]:align-middle"
        />
        {attachmentsComponent}
      </div>

      <div className="flex flex-wrap items-end justify-between gap-2 mb-2 mx-2">
        {languageDropdownComponent}
        <span
          className={clsx(
            "ml-auto text-nowrap text-xs",
            characterCount >= templateMaxLength
              ? "text-red-500"
              : "text-black-500",
          )}
        >
          {characterCount}/{templateMaxLength}
        </span>
      </div>
    </>
  );
}
